/**
 * Pages Router に残っているルートのパスパターン。
 *
 * App Router のページからこれらへ `next/link` で遷移すると必ずハード
 * ナビゲーションになるため、viewport prefetch は「破棄される HTML を
 * 返すためだけに getServerSideProps をフル実行させる」だけの無駄になる。
 * このリストは prefetch を無効化する判定に使う。
 *
 * `buildFacilityLink` などが返す動的ルート形式（`/facilities/prefectures/[prefectureSlug]/...`）
 * もプレフィックスで一致する。
 */
const PAGES_ROUTER_PATH_PATTERNS = [
  /^\/search(?:[/?#]|$)/,
  /^\/recommended(?:[/?#]|$)/,
  /^\/facilities(?:[/?#]|$)/,
  /^\/programs\/(?:\[|\d)/,
  /^\/me\/referral(?:[/?#]|$)/,
  /^\/me\/invitations(?:[/?#]|$)/,
  /^\/referral\/code(?:[/?#]|$)/,
]

/**
 * Check if the given href points to a Pages Router route
 *
 * @param href Path to check (pathname of UrlObject also accepted)
 * @returns boolean
 */
export const isPagesRouterPath = (href: string): boolean =>
  PAGES_ROUTER_PATH_PATTERNS.some((pattern) => pattern.test(href))
